module.exports = __webpack_public_path__ + "static/media/external-link-alt.1be02d8e.svg";